var map = {
	"./1.png": "c436",
	"./2.png": "6ba5",
	"./3.png": "aa21",
	"./4.png": "9ec4",
	"./5.png": "c9dd",
	"./6.png": "f72f",
	"./7.png": "580d",
	"./8.png": "611b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb88";